import MicIcon from '@/assets/icons/mic.svg?react'
import { Button } from '@/ui-kit'
import { CircleAlert, X } from 'lucide-react'

export const WaitingForSessionStep = ({ onBack }: { onBack: () => void }) => {
  return (
    <div className="m-auto flex max-w-[800px] flex-col items-center gap-4">
      <div className="flex w-full flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-8">
        <div className="flex flex-col items-center gap-4">
          <div className="text-body-2 text-gray-90 rounded-2xl border border-solid border-gray-100 p-2 px-3">
            Discuss the topic casually, like old acquaintances.
          </div>
          <div className="text-subtitle text-gray-70 font-semibold">Conversation will start shortly...</div>
          <div className="bg-black-to-white mt-4 flex size-24 items-center justify-center rounded-full">
            <div className="flex size-20 items-center justify-center rounded-full bg-gray-100">
              <MicIcon className="text-gray-80 size-10" />
            </div>
          </div>
          <div></div>
        </div>
        <div className="flex w-full flex-col items-center gap-8 border-t border-solid border-gray-100 pt-5">
          <div className="flex items-center justify-center gap-2">
            <span className="size-2 animate-pulse rounded-full bg-amber-500" />{' '}
            <span className="text-body-2 text-gray-90">Waiting for participants to join...</span>
          </div>
          <Button variant="bordered-gray" size="small" onClick={onBack} className="mt-2 gap-2">
            <X className="size-5" />
            Leave
          </Button>
        </div>
      </div>

      <div className="flex items-center gap-2 rounded-2xl border border-solid border-gray-100 px-7 py-4">
        <CircleAlert className="text-gray-90 size-5" />
        <span className="text-gray-90 text-body-2">
          A conversation session will be created once another worker enrolls in this project. Checking automatically...
        </span>
      </div>
    </div>
  )
}
